const getOr = require('lodash/fp/getOr');

function parseTransaction(transaction) {
  const p = path => getOr(null, path, transaction);

  return {
    type: p('tranTypeDesc'),
    currency: p('ccyTrade'),
    quantity: p('qty'),
    grossAmount: p('grossAmtBasePaymentCcy'),
    netAmount: parseFloat(p('netAmtTradeCcy')),
    tradeNumber: p('tradeNo'),
    tradeDate: p('tradeDate'),
    valueDate: p('valueDate'),
    purchasePrice: p('price'),
  };
}

module.exports = parseTransaction;
